var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-card",
        {
          attrs: {
            "no-body": true,
            "footer-class": "px-3 py-2 card-footer-action",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "p-3 clearfix" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "8" } }, [
                    _c("i", {
                      staticClass:
                        "fa fa-shield bg-primary p-3 font-2xl mr-3 float-left",
                    }),
                    _c("div", { staticClass: "h5 mb-0 mt-2" }, [
                      _vm._v(_vm._s(_vm.vulnLabel)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "text-muted font-weight-bold font-xs" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.sourceLabel) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "text-muted font-weight-bold font-xs" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.vulnerability.title) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "b-col",
                    {
                      staticClass: "align-middle",
                      staticStyle: { "align-self": "center" },
                      attrs: { cols: "4" },
                    },
                    [
                      _c("b-row", { staticClass: "float-right align-middle" }, [
                        _c("div", { staticStyle: { height: "40px" } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center pull-left severity-bug-icon",
                              style: { background: _vm.severityColor },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-bug",
                                staticStyle: {
                                  "font-size": "20px",
                                  padding: "10px",
                                },
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center pull-left severity-bug-label",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "20px",
                                    padding: "6px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.severityLabel) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              attrs: { slot: "footer", id: "vulnerability-info-footer" },
              slot: "footer",
            },
            [
              _c(
                "b-link",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.vulnerabilityDetailsModal",
                      modifiers: { vulnerabilityDetailsModal: true },
                    },
                  ],
                  staticClass: "font-weight-bold font-xs btn-block text-muted",
                },
                [
                  _vm._v(_vm._s(_vm.$t("message.view_details")) + "\n        "),
                  _c("i", {
                    staticClass: "fa fa-angle-right float-right font-lg",
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.vulnerability.published || _vm.vulnerability.aliases
        ? _c(
            "div",
            [
              _c(
                "b-card",
                [
                  _c("b-card-text", [
                    _vm.vulnerability.published
                      ? _c(
                          "span",
                          { staticClass: "font-weight-bold font-xs" },
                          [_vm._v("Published:\n        ")]
                        )
                      : _vm._e(),
                    _vm.vulnerability.published
                      ? _c(
                          "span",
                          {
                            staticClass: "font-weight-bold font-xs",
                            staticStyle: { "margin-right": "1.2rem" },
                          },
                          [_vm._v(_vm._s(_vm.prettyTimestamp))]
                        )
                      : _vm._e(),
                    _vm.vulnerability.aliases &&
                    _vm.vulnerability.aliases.length > 0
                      ? _c(
                          "span",
                          { staticClass: "font-weight-bold font-xs" },
                          [
                            _vm._v("\n          Aliases:\n          "),
                            _vm._l(
                              _vm.resolveVulnAliases(_vm.vulnerability.aliases),
                              function (alias) {
                                return _c(
                                  "span",
                                  [
                                    _c(
                                      "b-link",
                                      {
                                        staticStyle: { "margin-right": "1rem" },
                                        attrs: {
                                          href: `/vulnerabilities/${
                                            alias.source
                                          }/${encodeURIComponent(
                                            alias.vulnId
                                          )}`,
                                        },
                                      },
                                      [_vm._v(_vm._s(alias.vulnId))]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "overview",
              staticClass: "body-bg-color overview-chart",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: { active: "" },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-line-chart" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.overview"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm.vulnerability.description
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.overview") } },
                        [
                          _c(
                            "b-card-text",
                            [
                              _c("showdown", {
                                attrs: {
                                  markdown: _vm.vulnerability.description,
                                  flavor: "github",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.cvssBaseScore > 0
                            ? _c(
                                "div",
                                { attrs: { slot: "footer" }, slot: "footer" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "mb-sm-2 mb-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.cvss_base_score"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.cvssBaseScore)),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant:
                                                _vm.vulnerability.severity,
                                              value:
                                                (_vm.cvssBaseScore / 10) * 100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.cvss_impact_subscore"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.cvssImpactScore)),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value:
                                                (_vm.cvssImpactScore / 10) *
                                                100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.cvss_exploitability_subscore"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.cvssExploitScore)
                                            ),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value:
                                                (_vm.cvssExploitScore / 10) *
                                                100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("message.epss_score")
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.epssScore)),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value: _vm.epssScore * 100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.epss_percentile"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.epssPercentile)),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value: _vm.epssPercentile * 100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.owaspRRLikelihoodScore > 0
                            ? _c(
                                "div",
                                { attrs: { slot: "footer" }, slot: "footer" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "mb-sm-2 mb-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.owasp_rr_likelihood_score"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.owaspRRLikelihoodScore)
                                            ),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value:
                                                (_vm.owaspRRLikelihoodScore /
                                                  10) *
                                                100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.owasp_rr_technical_impact_score"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.owaspRRTechnicalImpactScore
                                              )
                                            ),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value:
                                                (_vm.owaspRRTechnicalImpactScore /
                                                  10) *
                                                100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mb-sm-2 mb-0 d-sm-down-none",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.owasp_rr_business_impact_score"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.owaspRRBusinessImpactScore
                                              )
                                            ),
                                          ]),
                                          _c("b-progress", {
                                            staticClass: "progress-xs mt-2",
                                            attrs: {
                                              height: "{}",
                                              precision: 1,
                                              variant: "severity-info",
                                              value:
                                                (_vm.owaspRRBusinessImpactScore /
                                                  10) *
                                                100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.vulnerability.cwes
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.weakness") } },
                        _vm._l(_vm.vulnerability.cwes, function (cwe) {
                          return _c("b-card-text", { key: cwe.cweId }, [
                            _c("a", { attrs: { href: _vm.cweLink(cwe) } }, [
                              _vm._v(_vm._s(_vm.cweLabel(cwe))),
                            ]),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.vulnerability.detail
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.details") } },
                        [
                          _c(
                            "b-card-text",
                            [
                              _c("showdown", {
                                attrs: { markdown: _vm.vulnerability.detail },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.vulnerability.recommendation
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.recommendation") } },
                        [
                          _c(
                            "b-card-text",
                            [
                              _c("showdown", {
                                attrs: {
                                  markdown: _vm.vulnerability.recommendation,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.vulnerability.references
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.references") } },
                        [
                          _c(
                            "b-card-text",
                            [
                              _c("showdown", {
                                attrs: {
                                  markdown: _vm.vulnerability.references,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.vulnerability.credits
                ? _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { title: this.$t("message.credits") } },
                        [
                          _c(
                            "b-card-text",
                            [
                              _c("showdown", {
                                attrs: { markdown: _vm.vulnerability.credits },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm.isPermitted(_vm.PERMISSIONS.VIEW_VULNERABILITY)
            ? _c(
                "b-tab",
                {
                  ref: "affectedprojects",
                  on: {
                    click: function ($event) {
                      return _vm.routeTo("affectedProjects")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-tasks" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.affected_projects")) +
                                "\n        "
                            ),
                            _c("b-badge", { attrs: { variant: "tab-total" } }, [
                              _vm._v(_vm._s(_vm.totalAffectedProjects)),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    923402737
                  ),
                },
                [
                  this.vulnerability.uuid
                    ? _c("affected-projects", {
                        key: this.uuid,
                        attrs: {
                          vulnerability: _vm.vulnerability.uuid,
                          source: _vm.source,
                          vulnId: _vm.vulnId,
                        },
                        on: {
                          total: function ($event) {
                            _vm.totalAffectedProjects = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("vulnerability-details-modal", {
        attrs: { vulnProp: _vm.clonedVulnerability },
        on: { vulnerabilityUpdated: _vm.syncVulnerabilityFields },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }